import Controller from "./class.Controller.js";

/**
 * TODO: Documentation
 */
export default class ViewController extends Controller {
	/**
	 * Like a Controller, but has an `$el`, which is built from its `className` and `tagName` attributes.
	 *
	 * @param {Object} options
	 * @param {*} options.model
	 * @param {&} options.collection
	 * @param {*} options.attributes
	 */
	constructor(options) {
		super(options);

		this.className = this.className || null;
		this.tagName = this.tagName || "div";

		this.$el = $("<" + this.tagName + "></" + this.tagName + ">");
		if (this.className) {
			this.$el.addClass(this.className);
		}
	}

	/**
	 * Select an element from this view using jQuery.
	 *
	 * @param {*} selector jQuery selector.
	 */
	$(selector) {
		return $(selector, this.$el);
	}

	/**
	 * Remove this element.
	 */
	remove() {
		this.$el.remove();
	}
}
